export enum QueueTransactionCommandEnum {
  // OSM import lifecycle (kdesu)
  DOWNLOAD_OSM_DATA = "DOWNLOAD_OSM_DATA",
  IMPORT_RESTAURANTS = "IMPORT_RESTAURANTS",
  GENERATE_TILES = "GENERATE_TILES",
  ACTIVATE_IMPORT = "ACTIVATE_IMPORT",
  IMPORT_BOUNDARY = "IMPORT_BOUNDARY",

  // Chlast domain
  GEO_DECODE = "GEO_DECODE",
  UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE",

  // Beerrally domain
  CREATE_RACE_REGISTRATION = "CREATE_RACE_REGISTRATION",
  UPDATE_RACE_REGISTRATION = "UPDATE_RACE_REGISTRATION",
  UPDATE_RACE = "UPDATE_RACE",
  CREATE_RACE = "CREATE_RACE",
  UPDATE_RACER_PROFILE = "UPDATE_RACER_PROFILE",
  APPLY_SCHEDULE = "APPLY_SCHEDULE",

  // Admin / maintenance
  CREATE_USER = "CREATE_USER",
  UPDATE_USER = "UPDATE_USER",
  RECORD_OPERATION = "RECORD_OPERATION",
  RESOLVE_OPERATIONS = "RESOLVE_OPERATIONS",
  CLEANUP_PROCESSED_OPERATIONS = "CLEANUP_PROCESSED_OPERATIONS",
  CLEANUP_OPERATION_HISTORY = "CLEANUP_OPERATION_HISTORY",

  // Logging
  LOG_ENTRY = "LOG_ENTRY",

  // WebSocket events (NotificationsQueue)
  OPERATION_STARTED = "OPERATION_STARTED",
  OPERATION_PROGRESS = "OPERATION_PROGRESS",
  OPERATION_COMPLETED = "OPERATION_COMPLETED",
  OPERATION_FAILED = "OPERATION_FAILED",
  OPERATIONS_RESOLVED = "OPERATIONS_RESOLVED",
}
